(function () {
  function fmt(n) {
    return "$" + Number(n).toFixed(2);
  }
  function fmtUnit(n) {
    const v = Math.abs(Number(n));
    if (v >= 1) return "$" + v.toFixed(2);
    if (v >= 0.01) return "$" + v.toFixed(3);
    if (v >= 0.001) return "$" + v.toFixed(4);
    return "$" + v.toFixed(5);
  }
  function fmtSize(b) {
    if (b < 1024) return b + " B";
    if (b < 1024 * 1024) return (b / 1024).toFixed(1) + " KB";
    return (b / 1024 / 1024).toFixed(1) + " MB";
  }
  function escapeHtml(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }
  function escapeAttr(s) {
    return escapeHtml(s);
  }

  function openLightbox(src, alt) {
    if (document.querySelector(".sv2-cep__lightbox")) return;
    const overlay = document.createElement("div");
    overlay.className = "sv2-cep__lightbox";
    overlay.innerHTML = `
      <button class="sv2-cep__lightbox-close" aria-label="Close">&times;</button>
      <img src="${escapeAttr(src)}" alt="${escapeAttr(alt || "")}">
    `;
    document.body.appendChild(overlay);
    const close = () => overlay.remove();
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay || e.target.classList.contains("sv2-cep__lightbox-close"))
        close();
    });
    document.addEventListener("keydown", function onKey(e) {
      if (e.key === "Escape") {
        close();
        document.removeEventListener("keydown", onKey);
      }
    });
  }

  function showFatal(root, msg) {
    const el = root.querySelector("[data-sv2-fatal]");
    if (el) {
      el.textContent = msg;
      el.hidden = false;
    }
    const boot = root.querySelector("[data-sv2-bootstrap]");
    if (boot) boot.remove();
  }

  function buildShell(config) {
    const cf = config.customFields || [];
    const fieldsHtml = cf
      .map((g, gi) => {
        const opts = (g.options || [])
          .map((o, oi) => {
            let badgeHtml = "";
            if (o.badge) {
              const bk = String(o.badge).toLowerCase();
              let cls = "sv2-cep__card-badge";
              if (bk === "free") cls += " sv2-cep__card-badge--success";
              else if (bk === "popular") cls += " sv2-cep__card-badge--info";
              else cls += " sv2-cep__card-badge--neutral";
              badgeHtml = `<span class="${cls}">${escapeHtml(o.badge)}</span>`;
            } else if (o.price > 0) {
              badgeHtml = `<span class="sv2-cep__card-badge sv2-cep__card-badge--neutral">+${fmt(o.price)}</span>`;
            }
            const iconHtml = o.icon
              ? `<i class="ti ${escapeAttr(o.icon)} sv2-cep__card-icon" aria-hidden="true"></i>`
              : "";
            const descHtml = o.description
              ? `<p class="sv2-cep__card-desc">${escapeHtml(o.description)}</p>`
              : "";
            return `
              <label class="sv2-cep__card" data-option-idx="${oi}">
                <input type="radio" name="sv2-cep-field-${gi}" value="${oi}" class="sv2-cep__card-input">
                <div class="sv2-cep__card-head">
                  <div class="sv2-cep__card-title">${iconHtml}<span>${escapeHtml(o.name)}</span></div>
                  ${badgeHtml}
                </div>
                ${descHtml}
              </label>
            `;
          })
          .join("");
        const imgUrl = (config.fieldImages || {})[g.name];
        const guideBtn = imgUrl
          ? `<button type="button" class="sv2-cep__field-guide" data-guide-src="${escapeAttr(imgUrl)}" data-guide-alt="${escapeAttr(g.name + " guide")}" aria-label="View ${escapeAttr(g.name)} guide"><img src="${escapeAttr(imgUrl)}" alt=""><span>View guide</span></button>`
          : "";
        return `
          <div class="sv2-cep__field" data-field-idx="${gi}">
            <div class="sv2-cep__field-header">
              <span class="sv2-cep__label">${escapeHtml(g.name)} <span class="sv2-cep__required">*</span></span>
              ${guideBtn}
            </div>
            <div class="sv2-cep__cards" data-count="${(g.options || []).length}">${opts}</div>
          </div>
        `;
      })
      .join("");

    const m = config.machine || {};
    const coresHtml = (m.coreSizes || [])
      .map((c) => {
        const isDefault = !!c.default;
        const badge = c.badge
          ? `<span class="sv2-cep__card-badge sv2-cep__card-badge--info">${escapeHtml(c.badge)}</span>`
          : "";
        return `
          <label class="sv2-cep__card sv2-cep__core${isDefault ? " is-active" : ""}" data-core-value="${escapeAttr(c.value)}">
            <input type="radio" name="sv2-cep-core" value="${escapeAttr(c.value)}" class="sv2-cep__card-input"${isDefault ? " checked" : ""}>
            <div class="sv2-cep__card-head"><div class="sv2-cep__card-title"><span>${escapeHtml(c.name)}</span></div>${badge}</div>
            <p class="sv2-cep__card-desc">${escapeHtml(c.desc || "")}</p>
          </label>
        `;
      })
      .join("");

    const unwindGroups = (m.unwindGroups || [])
      .map((grp) => {
        const cards = (grp.directions || [])
          .map((d) => {
            const img = d.image || ""; // resolved later against unwindImages map
            return `
              <label class="sv2-cep__wind-card" data-wind-id="${d.id}" data-wind-default-image="${escapeAttr(img)}">
                <input type="radio" name="sv2-cep-wind" value="${d.id}">
                <img alt="${escapeAttr(grp.title)} #${d.id} — ${escapeAttr(d.label)}" loading="lazy">
                <p class="sv2-cep__wind-name">#${d.id} · ${escapeHtml(d.label)}</p>
              </label>
            `;
          })
          .join("");
        const subtitle = grp.subtitle
          ? `<span class="sv2-cep__wind-group-hint">${escapeHtml(grp.subtitle)}</span>`
          : "";
        return `
          <div class="sv2-cep__wind-group">
            <p class="sv2-cep__wind-group-title">${escapeHtml(grp.title)} ${subtitle}</p>
            <div class="sv2-cep__winds">${cards}</div>
          </div>
        `;
      })
      .join("");

    const guideLink =
      m.guideUrl && m.guideLinkLabel
        ? `<a class="sv2-cep__wind-guide" href="${escapeAttr(m.guideUrl)}" target="_blank" rel="noopener"><i class="ti ti-download" aria-hidden="true"></i> ${escapeHtml(m.guideLinkLabel)}</a>`
        : "";

    const trust = (config.trust || [])
      .map(
        (t) => `
        <div class="sv2-cep__trust-item">
          <i class="ti ${escapeAttr(t.icon)}" aria-hidden="true"></i>
          <span>${escapeHtml(t.text)}</span>
        </div>
      `,
      )
      .join("");

    const uploadHtml = config.artwork?.enabled
      ? `
      <div class="sv2-cep__row">
        <label class="sv2-cep__label">${escapeHtml(config.artwork.label || "Upload Artwork")} <span class="sv2-cep__required">*</span></label>
        <label class="sv2-cep__upload" data-sv2-upload-wrap>
          <input type="file" data-sv2-upload accept=".pdf,.ai,.eps,.png,.jpg,.jpeg,.svg,.tiff,.psd" hidden>
          <div class="sv2-cep__upload-inner" data-sv2-upload-empty>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
            <div class="sv2-cep__upload-text">
              <strong>Click to upload</strong> or drag and drop
              <small>PDF, AI, EPS, PNG, JPG, SVG (max 25 MB)</small>
            </div>
          </div>
          <div class="sv2-cep__upload-inner" data-sv2-upload-filled hidden>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="sv2-cep__upload-check"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
            <div class="sv2-cep__upload-text">
              <strong data-sv2-upload-filename></strong>
              <small data-sv2-upload-filesize></small>
            </div>
            <button type="button" class="sv2-cep__upload-clear" data-sv2-upload-clear aria-label="Remove file">×</button>
          </div>
        </label>
        ${config.artwork.helpText ? `<p class="sv2-cep__upload-help">${escapeHtml(config.artwork.helpText)}</p>` : ""}
      </div>`
      : "";

    return `
      <h2 class="sv2-cep__title">${escapeHtml(config.heading || "")}</h2>
      ${config.subheading ? `<p class="sv2-cep__subtitle">${escapeHtml(config.subheading)}</p>` : ""}

      <div class="sv2-cep__row">
        <label class="sv2-cep__label">Size <span class="sv2-cep__required">*</span></label>
        <div class="sv2-cep__sizes" data-sv2-sizes></div>
      </div>

      <div class="sv2-cep__row sv2-cep__custom-size" data-sv2-custom-size hidden>
        <label class="sv2-cep__label">Custom dimensions (inches)</label>
        <div class="sv2-cep__custom-inputs">
          <input type="number" min="0.25" step="0.25" placeholder="Width" data-sv2-width>
          <span>×</span>
          <input type="number" min="0.25" step="0.25" placeholder="Height" data-sv2-height>
        </div>
      </div>

      <div class="sv2-cep__row">
        <label class="sv2-cep__label">Select a quantity <span class="sv2-cep__required">*</span></label>
        <div class="sv2-cep__qty-options" data-sv2-qty-options></div>
        <p class="sv2-cep__qty-nudge" data-sv2-qty-nudge hidden></p>
      </div>

      <div data-sv2-custom-fields>${fieldsHtml}</div>

      <div class="sv2-cep__machine-panel" data-sv2-machine-followup hidden>
        <div class="sv2-cep__machine-head">
          <i class="ti ti-settings-cog" aria-hidden="true"></i>
          <span class="sv2-cep__machine-title">${escapeHtml(m.title || "Machine application specs")}</span>
          ${m.selectedBadge ? `<span class="sv2-cep__machine-badge">${escapeHtml(m.selectedBadge)}</span>` : ""}
        </div>

        <div class="sv2-cep__machine-danger">
          <i class="ti ti-alert-triangle" aria-hidden="true"></i>
          <div>
            <strong>${escapeHtml(m.warning?.title || "")}</strong>
            ${escapeHtml(m.warning?.body || "")}
          </div>
        </div>

        <div class="sv2-cep__machine-row">
          <label class="sv2-cep__machine-label">${escapeHtml(m.modelLabel || "Machine make & model")} <span class="sv2-cep__required">*</span></label>
          <input type="text" class="sv2-cep__machine-input" data-sv2-machine-model placeholder="${escapeAttr(m.modelPlaceholder || "")}" autocomplete="off">
          ${m.modelHelp ? `<p class="sv2-cep__machine-help">${escapeHtml(m.modelHelp)}</p>` : ""}
        </div>

        <div class="sv2-cep__machine-row">
          <label class="sv2-cep__machine-label">${escapeHtml(m.coreSizeLabel || "Core size")} <span class="sv2-cep__required">*</span></label>
          <div class="sv2-cep__cores" data-sv2-cores>${coresHtml}</div>
        </div>

        <div class="sv2-cep__machine-row">
          <label class="sv2-cep__machine-label">${escapeHtml(m.labelsPerRollLabel || "Labels per roll")}</label>
          <div class="sv2-cep__machine-inline">
            <input type="number" min="1" step="1" class="sv2-cep__machine-input sv2-cep__machine-input--narrow" data-sv2-labels-per-roll value="${m.labelsPerRollDefault || 1000}">
            <p class="sv2-cep__machine-help" data-sv2-roll-helper></p>
          </div>
        </div>

        <div class="sv2-cep__machine-row">
          <div class="sv2-cep__wind-head">
            <label class="sv2-cep__machine-label">${escapeHtml(m.unwindLabel || "Label unwind direction")} <span class="sv2-cep__required">*</span></label>
            ${guideLink}
          </div>
          ${m.unwindHelp ? `<p class="sv2-cep__machine-help" style="margin: 0 0 14px;">${escapeHtml(m.unwindHelp)}</p>` : ""}
          ${unwindGroups}
        </div>

        <div class="sv2-cep__confirm-gate">
          <p class="sv2-cep__confirm-title"><i class="ti ti-shield-check" aria-hidden="true"></i> ${escapeHtml(m.confirmTitle || "Confirm your specs before continuing")}</p>
          <div class="sv2-cep__confirm-summary">
            <p class="sv2-cep__confirm-eyebrow">${escapeHtml(m.confirmEyebrow || "Your machine spec summary")}</p>
            <p class="sv2-cep__confirm-text" data-sv2-spec-summary>—</p>
          </div>
          <label class="sv2-cep__confirm-check">
            <input type="checkbox" data-sv2-confirm>
            <span>${escapeHtml(m.confirmCheckText || "")}</span>
          </label>
        </div>

        ${m.reprintGuarantee ? `<p class="sv2-cep__reprint"><i class="ti ti-rotate" aria-hidden="true"></i> ${escapeHtml(m.reprintGuarantee)}</p>` : ""}
      </div>

      <div class="sv2-cep__row sv2-cep__addons" data-sv2-addons-wrap${(config.addons || []).length ? "" : " hidden"}>
        <label class="sv2-cep__label">Add-ons</label>
        <div data-sv2-addons></div>
      </div>

      ${uploadHtml}

      <div class="sv2-cep__summary">
        <div class="sv2-cep__summary-row"><span>Unit price</span><span data-sv2-unit-price>—</span></div>
        <div class="sv2-cep__summary-row"><span>Subtotal</span><span data-sv2-subtotal>—</span></div>
        <div class="sv2-cep__summary-row sv2-cep__summary-row--addons" data-sv2-addons-row hidden><span>Add-ons</span><span data-sv2-addons-total>—</span></div>
        <div class="sv2-cep__summary-row sv2-cep__summary-row--options" data-sv2-options-row hidden><span>Options</span><span data-sv2-options-total>—</span></div>
        <div class="sv2-cep__summary-row"><span>${escapeHtml(config.feeLabel || "Processing fee")} <span class="sv2-cep__fee-badge">Fixed</span></span><span data-sv2-fee>—</span></div>
        <div class="sv2-cep__summary-row sv2-cep__summary-row--total"><span>Total</span><span data-sv2-total>—</span></div>
      </div>

      <button type="button" class="sv2-cep__submit" data-sv2-submit>
        <span data-sv2-submit-label>${escapeHtml(config.ctaLabel || "Continue to checkout")}</span>
        <span data-sv2-submit-spinner hidden>Processing…</span>
      </button>

      <p class="sv2-cep__error" data-sv2-error hidden></p>

      ${trust ? `<div class="sv2-cep__trust">${trust}</div>` : ""}
    `;
  }

  function setupConfigurator(root, config, productTitle, unwindImages) {
    const proxyUrl = root.dataset.proxyUrl;
    const uploadUrl = root.dataset.uploadUrl;

    const presets = config.sizePresets || [];
    const tiers = (config.volumeTiers || []).slice().sort((a, b) => a.min - b.min);
    const qtyOptions = (config.quantityOptions || [])
      .map((n) => parseInt(n, 10))
      .filter((n) => Number.isFinite(n) && n > 0)
      .sort((a, b) => a - b);
    const addons = config.addons || [];
    const customFields = config.customFields || [];
    const pricePerSqin = Number(config.pricePerSqin) || 0;
    const processingFee = Number(config.processingFee) || 0;
    const allowCustom = !!config.allowCustomSize;

    const defaultCore = (config.machine?.coreSizes || []).find((c) => c.default);
    const initialCore = defaultCore ? defaultCore.value : config.machine?.coreSizes?.[0]?.value || '3"';
    const labelsPerRollDefault = Number(config.machine?.labelsPerRollDefault) || 1000;

    const state = {
      sizeIdx: 0,
      customW: presets[0] ? String(presets[0].w) : "",
      customH: presets[0] ? String(presets[0].h) : "",
      qty: qtyOptions[0] || 100,
      selectedAddons: new Set(),
      customFieldSel: {},
      machineModel: "",
      coreSize: initialCore,
      labelsPerRoll: labelsPerRollDefault,
      windDirection: null,
      specConfirmed: false,
      artworkFile: null,
    };

    const $ = (sel) => root.querySelector(sel);
    const $$ = (sel) => Array.from(root.querySelectorAll(sel));

    const sizesEl = $("[data-sv2-sizes]");
    const customSizeEl = $("[data-sv2-custom-size]");
    const widthInput = $("[data-sv2-width]");
    const heightInput = $("[data-sv2-height]");
    const qtyOptionsEl = $("[data-sv2-qty-options]");
    const qtyNudgeEl = $("[data-sv2-qty-nudge]");
    const customFieldsEl = $("[data-sv2-custom-fields]");
    const machineFollowupEl = $("[data-sv2-machine-followup]");
    const machineModelInput = $("[data-sv2-machine-model]");
    const coresEl = $("[data-sv2-cores]");
    const labelsPerRollInput = $("[data-sv2-labels-per-roll]");
    const rollHelperEl = $("[data-sv2-roll-helper]");
    const specSummaryEl = $("[data-sv2-spec-summary]");
    const specConfirmEl = $("[data-sv2-confirm]");
    const addonsWrap = $("[data-sv2-addons-wrap]");
    const addonsEl = $("[data-sv2-addons]");
    const uploadInput = $("[data-sv2-upload]");
    const uploadEmpty = $("[data-sv2-upload-empty]");
    const uploadFilled = $("[data-sv2-upload-filled]");
    const uploadFilename = $("[data-sv2-upload-filename]");
    const uploadFilesize = $("[data-sv2-upload-filesize]");
    const uploadClear = $("[data-sv2-upload-clear]");
    const unitPriceEl = $("[data-sv2-unit-price]");
    const subtotalEl = $("[data-sv2-subtotal]");
    const addonsRowEl = $("[data-sv2-addons-row]");
    const addonsTotalEl = $("[data-sv2-addons-total]");
    const optionsRowEl = $("[data-sv2-options-row]");
    const optionsTotalEl = $("[data-sv2-options-total]");
    const feeEl = $("[data-sv2-fee]");
    const totalEl = $("[data-sv2-total]");
    const submitBtn = $("[data-sv2-submit]");
    const submitLabel = $("[data-sv2-submit-label]");
    const submitSpinner = $("[data-sv2-submit-spinner]");
    const errorEl = $("[data-sv2-error]");

    // Resolve wind-card images: prefer config-provided URL, fallback to theme asset map.
    $$(".sv2-cep__wind-card").forEach((card) => {
      const id = card.dataset.windId;
      const defaultImg = card.dataset.windDefaultImage;
      const fallback = unwindImages && unwindImages[id];
      const src = defaultImg || fallback || "";
      const img = card.querySelector("img");
      if (img && src) img.src = src;
    });

    // Build wind info lookup from config for spec summary.
    const windInfo = {};
    (config.machine?.unwindGroups || []).forEach((grp) => {
      (grp.directions || []).forEach((d) => {
        windInfo[d.id] = `${grp.title} — ${d.label}`;
      });
    });

    // Render size buttons
    presets.forEach((p, i) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "sv2-cep__size-btn";
      btn.textContent = `${p.w}" × ${p.h}"`;
      btn.dataset.idx = String(i);
      sizesEl.appendChild(btn);
    });
    if (allowCustom) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "sv2-cep__size-btn";
      btn.textContent = "Custom";
      btn.dataset.idx = "custom";
      sizesEl.appendChild(btn);
    }

    // Render qty options
    qtyOptions.forEach((q, i) => {
      const row = document.createElement("label");
      row.className = "sv2-cep__qty-row";
      row.dataset.qty = String(q);
      row.innerHTML = `
        <input type="radio" name="sv2-cep-qty" value="${q}" ${i === 0 ? "checked" : ""}>
        <span class="sv2-cep__qty-num">${q.toLocaleString()}<small>units</small></span>
        <span class="sv2-cep__qty-total">
          <span class="sv2-cep__qty-total-amount" data-qty-total-amount>—</span>
          <span class="sv2-cep__qty-total-unit" data-qty-total-unit></span>
        </span>
        <span class="sv2-cep__qty-save" data-qty-save></span>
      `;
      if (i === 0) row.classList.add("is-active");
      qtyOptionsEl.appendChild(row);
    });

    // Render addons
    addons.forEach((a, i) => {
      const wrap = document.createElement("label");
      wrap.innerHTML = `
        <input type="checkbox" data-addon-idx="${i}">
        <span class="sv2-cep__addons-name">${escapeHtml(a.name)}</span>
        <span class="sv2-cep__addons-price">+${fmt(a.price)}</span>
      `;
      addonsEl.appendChild(wrap);
    });

    function getCurrentSize() {
      if (state.sizeIdx === "custom") {
        const w = parseFloat(state.customW);
        const h = parseFloat(state.customH);
        if (!w || !h) return null;
        return { w, h, label: `${w}" × ${h}" (custom)` };
      }
      const p = presets[state.sizeIdx];
      if (!p) return null;
      return { w: p.w, h: p.h, label: `${p.w}" × ${p.h}"` };
    }

    function tierFor(qty) {
      let mult = 1;
      for (const t of tiers) if (qty >= t.min) mult = t.mult;
      return mult;
    }
    function computeUnitPrice(size, qty) {
      return size.w * size.h * pricePerSqin * tierFor(qty);
    }
    function customFieldsTotal() {
      let sum = 0;
      Object.entries(state.customFieldSel).forEach(([gi, oi]) => {
        const opt = customFields[parseInt(gi, 10)]?.options?.[oi];
        if (opt) sum += Number(opt.price) || 0;
      });
      return sum;
    }
    function customFieldsValid() {
      return customFields.every((_g, gi) => state.customFieldSel[gi] != null);
    }
    function isMachineSelected() {
      return customFields.some((g, gi) => {
        const oi = state.customFieldSel[gi];
        if (oi == null) return false;
        return /machine/i.test(g.options[oi]?.name || "");
      });
    }
    function machineSpecsValid() {
      if (!isMachineSelected()) return true;
      if (!state.machineModel) return false;
      if (!state.coreSize) return false;
      if (!state.windDirection) return false;
      if (!Number.isFinite(state.labelsPerRoll) || state.labelsPerRoll <= 0) return false;
      if (!state.specConfirmed) return false;
      return true;
    }
    function getWindDescription(id) {
      return windInfo[id] || null;
    }
    function updateSpecSummary() {
      if (!specSummaryEl) return;
      const parts = [];
      parts.push(`${state.coreSize} core`);
      const desc = getWindDescription(state.windDirection);
      parts.push(desc ? `#${state.windDirection} ${desc}` : "unwind direction not selected");
      if (Number.isFinite(state.labelsPerRoll) && state.labelsPerRoll > 0) {
        parts.push(`${state.labelsPerRoll.toLocaleString()} labels per roll`);
      }
      specSummaryEl.textContent = parts.join(" · ");
    }
    function updateRollHelper() {
      if (!rollHelperEl) return;
      const total = state.qty;
      const perRoll = state.labelsPerRoll;
      const tpl =
        config.machine?.rollHelperTemplate ||
        "We'll split your {qty} quantity into {rolls} roll{s}. Larger rolls require larger cores.";
      if (Number.isFinite(total) && Number.isFinite(perRoll) && perRoll > 0) {
        const rolls = Math.ceil(total / perRoll);
        rollHelperEl.textContent = tpl
          .replace("{qty}", total.toLocaleString())
          .replace("{rolls}", String(rolls))
          .replace("{s}", rolls === 1 ? "" : "s");
      } else {
        rollHelperEl.textContent = "We'll split your order into rolls of this size.";
      }
    }

    function canSubmit(size) {
      if (!size) return false;
      if (!customFieldsValid()) return false;
      if (!machineSpecsValid()) return false;
      if (config.artwork?.enabled) {
        if (!state.artworkFile) return false;
        if (state.artworkFile.uploading) return false;
        if (!state.artworkFile.url) return false;
      }
      return true;
    }

    function compute() {
      const size = getCurrentSize();
      const qty = state.qty;
      if (!size) {
        unitPriceEl.textContent = "—";
        subtotalEl.textContent = "—";
        feeEl.textContent = fmt(processingFee);
        totalEl.textContent = "—";
        qtyOptionsEl
          .querySelectorAll("[data-qty-total-amount]")
          .forEach((el) => (el.textContent = "—"));
        qtyOptionsEl
          .querySelectorAll("[data-qty-total-unit]")
          .forEach((el) => (el.textContent = ""));
        qtyOptionsEl
          .querySelectorAll("[data-qty-save]")
          .forEach((el) => (el.textContent = ""));
        if (qtyNudgeEl) qtyNudgeEl.hidden = true;
        if (machineFollowupEl) machineFollowupEl.hidden = !isMachineSelected();
        submitBtn.disabled = true;
        return;
      }

      const sqin = size.w * size.h;
      const baselineUnit = sqin * pricePerSqin;
      qtyOptions.forEach((q) => {
        const unit = computeUnitPrice(size, q);
        const total = unit * q;
        const row = qtyOptionsEl.querySelector(`[data-qty="${q}"]`);
        if (!row) return;
        row.querySelector("[data-qty-total-amount]").textContent = fmt(total);
        row.querySelector("[data-qty-total-unit]").textContent = `${fmtUnit(unit)} / each`;
        const saveEl = row.querySelector("[data-qty-save]");
        if (q === qtyOptions[0]) {
          saveEl.textContent = "";
        } else {
          const linear = baselineUnit * q;
          if (linear > 0) {
            const savePct = Math.round((1 - total / linear) * 100);
            saveEl.textContent = savePct > 0 ? `Save ${savePct}%` : "";
          }
        }
      });

      const unit = computeUnitPrice(size, qty);
      const subtotal = unit * qty;
      let addonsTotal = 0;
      state.selectedAddons.forEach((i) => (addonsTotal += Number(addons[i].price) || 0));
      const optionsTotal = customFieldsTotal();
      const total = subtotal + addonsTotal + optionsTotal + processingFee;

      unitPriceEl.textContent = fmtUnit(unit);
      subtotalEl.textContent = `${fmt(subtotal)} (${qty.toLocaleString()} × ${fmtUnit(unit)})`;
      feeEl.textContent = fmt(processingFee);
      totalEl.textContent = fmt(total);

      addonsRowEl.hidden = !(addonsTotal > 0);
      if (addonsTotal > 0) addonsTotalEl.textContent = fmt(addonsTotal);
      optionsRowEl.hidden = !(optionsTotal > 0);
      if (optionsTotal > 0) optionsTotalEl.textContent = fmt(optionsTotal);

      if (qtyNudgeEl) {
        let nudge = null;
        for (const q of qtyOptions) {
          if (q <= qty) continue;
          const u = computeUnitPrice(size, q);
          if (u < unit - 0.0001) {
            nudge = { qty: q, perLabelSave: unit - u, totalSave: (unit - u) * q };
            break;
          }
        }
        if (nudge) {
          qtyNudgeEl.innerHTML = `<i class="ti ti-arrow-up-right" aria-hidden="true"></i> Bump to ${nudge.qty.toLocaleString()} to save ${fmt(nudge.totalSave)} total`;
          qtyNudgeEl.hidden = false;
        } else {
          qtyNudgeEl.hidden = true;
        }
      }

      if (machineFollowupEl) machineFollowupEl.hidden = !isMachineSelected();
      updateRollHelper();
      submitBtn.disabled = !canSubmit(size);
    }

    // Wire up event handlers
    sizesEl.addEventListener("click", (e) => {
      const btn = e.target.closest(".sv2-cep__size-btn");
      if (!btn) return;
      sizesEl
        .querySelectorAll(".sv2-cep__size-btn")
        .forEach((b) => b.classList.remove("is-active"));
      btn.classList.add("is-active");
      const v = btn.dataset.idx;
      state.sizeIdx = v === "custom" ? "custom" : parseInt(v, 10);
      customSizeEl.hidden = v !== "custom";
      if (v !== "custom") {
        const p = presets[parseInt(v, 10)];
        if (p) {
          widthInput.value = String(p.w);
          heightInput.value = String(p.h);
          state.customW = String(p.w);
          state.customH = String(p.h);
        }
      }
      compute();
    });
    widthInput.addEventListener("input", () => {
      state.customW = widthInput.value;
      compute();
    });
    heightInput.addEventListener("input", () => {
      state.customH = heightInput.value;
      compute();
    });
    qtyOptionsEl.addEventListener("change", (e) => {
      if (e.target.type !== "radio") return;
      state.qty = parseInt(e.target.value, 10);
      qtyOptionsEl
        .querySelectorAll(".sv2-cep__qty-row")
        .forEach((r) => r.classList.remove("is-active"));
      e.target.closest(".sv2-cep__qty-row").classList.add("is-active");
      compute();
    });
    customFieldsEl.addEventListener("change", (e) => {
      if (e.target.type !== "radio") return;
      const field = e.target.closest(".sv2-cep__field");
      if (!field) return;
      const gi = parseInt(field.dataset.fieldIdx, 10);
      const oi = parseInt(e.target.value, 10);
      state.customFieldSel[gi] = oi;
      field.querySelectorAll(".sv2-cep__card").forEach((o) => o.classList.remove("is-active"));
      e.target.closest(".sv2-cep__card").classList.add("is-active");
      compute();
    });
    customFieldsEl.addEventListener("click", (e) => {
      const btn = e.target.closest(".sv2-cep__field-guide");
      if (!btn) return;
      e.preventDefault();
      openLightbox(btn.dataset.guideSrc, btn.dataset.guideAlt);
    });
    if (machineModelInput) {
      machineModelInput.addEventListener("input", () => {
        state.machineModel = machineModelInput.value.trim();
        updateSpecSummary();
        compute();
      });
    }
    if (coresEl) {
      coresEl.addEventListener("change", (e) => {
        if (e.target.type !== "radio") return;
        state.coreSize = e.target.value;
        coresEl.querySelectorAll(".sv2-cep__core").forEach((c) => c.classList.remove("is-active"));
        e.target.closest(".sv2-cep__core").classList.add("is-active");
        updateSpecSummary();
        compute();
      });
    }
    if (labelsPerRollInput) {
      labelsPerRollInput.addEventListener("input", () => {
        const n = parseInt(labelsPerRollInput.value, 10);
        state.labelsPerRoll = Number.isFinite(n) && n > 0 ? n : null;
        updateSpecSummary();
        compute();
      });
    }
    if (machineFollowupEl) {
      machineFollowupEl.addEventListener("change", (e) => {
        if (e.target.type !== "radio") return;
        if (!/^sv2-cep-wind/.test(e.target.name)) return;
        const id = parseInt(e.target.value, 10);
        state.windDirection = id;
        machineFollowupEl
          .querySelectorAll(".sv2-cep__wind-card")
          .forEach((c) => c.classList.remove("is-active"));
        e.target.closest(".sv2-cep__wind-card").classList.add("is-active");
        updateSpecSummary();
        compute();
      });
    }
    if (specConfirmEl) {
      specConfirmEl.addEventListener("change", () => {
        state.specConfirmed = specConfirmEl.checked;
        compute();
      });
    }
    addonsEl.addEventListener("change", (e) => {
      const cb = e.target;
      if (cb.type !== "checkbox") return;
      const i = parseInt(cb.dataset.addonIdx, 10);
      if (cb.checked) state.selectedAddons.add(i);
      else state.selectedAddons.delete(i);
      compute();
    });

    if (uploadInput) {
      uploadInput.addEventListener("change", async () => {
        const f = uploadInput.files?.[0];
        if (!f) return;
        if (f.size > 25 * 1024 * 1024) {
          showError("File too large. Max 25 MB.");
          uploadInput.value = "";
          return;
        }
        state.artworkFile = { name: f.name, size: f.size, url: null, uploading: true };
        uploadFilename.textContent = f.name + " — uploading…";
        uploadFilesize.textContent = fmtSize(f.size);
        uploadEmpty.hidden = true;
        uploadFilled.hidden = false;
        errorEl.hidden = true;
        compute();

        try {
          const fd = new FormData();
          fd.append("file", f);
          const resp = await fetch(uploadUrl, { method: "POST", body: fd });
          const data = await resp.json();
          if (!resp.ok || !data.ok) {
            showError(
              "Upload failed: " +
                (data.error || data.userErrors?.[0]?.message || resp.statusText),
            );
            state.artworkFile = null;
            uploadInput.value = "";
            uploadEmpty.hidden = false;
            uploadFilled.hidden = true;
            compute();
            return;
          }
          state.artworkFile = {
            name: f.name,
            size: f.size,
            url: data.url,
            fileId: data.fileId,
            uploading: false,
          };
          uploadFilename.textContent = f.name;
          compute();
        } catch (e) {
          showError("Upload error: " + e.message);
          state.artworkFile = null;
          uploadInput.value = "";
          uploadEmpty.hidden = false;
          uploadFilled.hidden = true;
          compute();
        }
      });
      uploadClear.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        state.artworkFile = null;
        uploadInput.value = "";
        uploadEmpty.hidden = false;
        uploadFilled.hidden = true;
        compute();
      });
    }

    sizesEl.querySelector('[data-idx="0"]')?.classList.add("is-active");
    if (presets[0]) {
      widthInput.value = String(presets[0].w);
      heightInput.value = String(presets[0].h);
    }
    updateSpecSummary();
    compute();

    submitBtn.addEventListener("click", async () => {
      const size = getCurrentSize();
      const qty = state.qty;
      if (!size) {
        showError("Please select a size.");
        return;
      }
      if (!customFieldsValid()) {
        const missing = customFields
          .filter((_g, gi) => state.customFieldSel[gi] == null)
          .map((g) => g.name);
        showError(`Please select: ${missing.join(", ")}.`);
        return;
      }
      if (isMachineSelected() && !machineSpecsValid()) {
        const missing = [];
        if (!state.machineModel) missing.push("Machine make & model");
        if (!state.windDirection) missing.push("Label unwind direction");
        if (!Number.isFinite(state.labelsPerRoll) || state.labelsPerRoll <= 0)
          missing.push("Labels per roll");
        if (!state.specConfirmed) missing.push("Spec confirmation");
        showError(`Machine application requires: ${missing.join(", ")}.`);
        return;
      }
      if (config.artwork?.enabled && !state.artworkFile) {
        showError("Please upload your artwork.");
        return;
      }

      const unit = computeUnitPrice(size, qty);
      const sqin = size.w * size.h;
      const mult = tierFor(qty);

      const optionsProps = {};
      customFields.forEach((g, gi) => {
        const oi = state.customFieldSel[gi];
        if (oi != null) optionsProps[g.name] = g.options[oi].name;
      });
      if (isMachineSelected()) {
        optionsProps["Machine make & model"] = state.machineModel;
        optionsProps["Core size"] = state.coreSize;
        optionsProps["Labels per roll"] = String(state.labelsPerRoll);
        const desc = getWindDescription(state.windDirection);
        if (desc) optionsProps["Label unwind direction"] = `#${state.windDirection} — ${desc}`;
        optionsProps["Spec confirmation timestamp"] = new Date().toISOString();
      }

      const mainProps = {
        "Width (in)": String(size.w),
        "Height (in)": String(size.h),
        "Area (sq in)": sqin.toFixed(2),
        ...optionsProps,
      };
      if (state.artworkFile?.url) {
        mainProps["Artwork file"] = state.artworkFile.name;
        mainProps["Artwork URL"] = state.artworkFile.url;
      }

      submitBtn.disabled = true;
      submitLabel.hidden = true;
      submitSpinner.hidden = false;
      errorEl.hidden = true;

      const optionLineItems = customFields
        .map((g, gi) => {
          const oi = state.customFieldSel[gi];
          if (oi == null) return null;
          const o = g.options[oi];
          if (!o.price || o.price <= 0) return null;
          return {
            title: `${g.name}: ${o.name}`,
            unitPrice: Number(o.price),
            quantity: 1,
            properties: { For: productTitle },
          };
        })
        .filter(Boolean);

      const body = {
        main: {
          title: `${productTitle} — ${size.label}`,
          unitPrice: parseFloat(unit.toFixed(2)),
          quantity: qty,
          properties: mainProps,
        },
        addons: [
          ...Array.from(state.selectedAddons).map((i) => ({
            title: addons[i].name,
            unitPrice: Number(addons[i].price),
            quantity: 1,
            properties: { For: productTitle },
          })),
          ...optionLineItems,
        ],
        processingFee: { amount: processingFee },
        note: `Cart Engine quote — volume mult ${mult.toFixed(3)}`,
        tags: ["cart-engine"],
      };

      try {
        const resp = await fetch(proxyUrl, {
          method: "POST",
          headers: { "content-type": "application/json", accept: "application/json" },
          body: JSON.stringify(body),
        });
        const data = await resp.json();
        if (!resp.ok || !data.ok) {
          showError(
            "Could not create quote: " +
              (data.errors?.[0]?.message || data.error || resp.statusText),
          );
          return;
        }
        window.location.href = data.checkoutUrl;
      } catch (e) {
        showError("Network error: " + e.message);
      } finally {
        submitBtn.disabled = false;
        submitLabel.hidden = false;
        submitSpinner.hidden = true;
      }
    });

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }
  }

  async function init(root) {
    const productTitle = root.dataset.productTitle;
    const configUrl = root.dataset.configUrl;
    let unwindImages = {};
    try {
      unwindImages = JSON.parse(root.dataset.unwindImages || "{}");
    } catch {}

    let config;
    try {
      const resp = await fetch(configUrl, {
        headers: { accept: "application/json" },
        credentials: "same-origin",
      });
      const data = await resp.json();
      if (!resp.ok || !data.ok || !data.config) {
        throw new Error(data.error || "Configurator unavailable");
      }
      config = data.config;
    } catch (e) {
      showFatal(
        root,
        "Could not load configurator. Please refresh the page or contact support. (" +
          e.message +
          ")",
      );
      return;
    }

    const shell = root.querySelector("[data-sv2-shell]");
    shell.innerHTML = buildShell(config);
    const boot = root.querySelector("[data-sv2-bootstrap]");
    if (boot) boot.remove();
    shell.hidden = false;

    setupConfigurator(root, config, productTitle, unwindImages);
  }

  document.querySelectorAll(".sv2-cep").forEach(init);
})();
